import { Outlet } from "react-router-dom"

const GuestLayout: React.FC = () => {
  return (
    <div className="min-h-screen gradient-bg flex items-center justify-center p-4">
      <Outlet />
    </div>
  )
}

export default GuestLayout
